enum FlashcardAnswerValue {
    WRONG = 1,
    ALMOST = 2,
    RIGHT = 3
}

export default FlashcardAnswerValue;
